import { firstExportAudioFlow } from "./flows/firstExportAudioFlow";
import { firstExportClarityFlow } from "./flows/firstExportClarityFlow";
import { firstExportCompositeFlow } from "./flows/firstExportCompositeFlow";
import { firstExportTranscriptFlow } from "./flows/firstExportTranscriptFlow";
import { firstRecordVideoFlow } from "./flows/firstRecordVideoFlow";
import type { ActivationFlowDefinition, ActivationFlowId } from "./types";

const FLOW_REGISTRY: Record<ActivationFlowId, ActivationFlowDefinition> = {
    first_export_audio: firstExportAudioFlow,
    first_export_clarity: firstExportClarityFlow,
    first_export_composite: firstExportCompositeFlow,
    first_export_transcript: firstExportTranscriptFlow,
    first_record_video: firstRecordVideoFlow,
};

export const getActivationFlowDefinition = (
    flowId: ActivationFlowId | string | null | undefined
): ActivationFlowDefinition | null => {
    if (!flowId) return null;
    const key = String(flowId).trim() as ActivationFlowId;
    return FLOW_REGISTRY[key] ?? null;
};

export const getAllActivationFlows = (): ActivationFlowDefinition[] =>
    Object.values(FLOW_REGISTRY);
